import { useAppContext } from 'common/context/app-context'

export const useAppContextOrgInfo = () => {
  const { orgInfoCtx } = useAppContext()
  return { ...orgInfoCtx }
}
